import React, { useState } from 'react'
import Handler from '../../../Helpers/Handler'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { contentLoadingChange } from '../../../Reducer/componentSlice'

const FinalVerify = ({ customerDetails, onVerified }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState({
        firstName: customerDetails?.firstName,
        lastName: customerDetails?.lastName
    })

    const handleChange = (e) => {
        setName((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const renderStatus = (isValid) => {
        return isValid ? (
            <span className='badge bg-success'>Valid</span>
        ) : (
            <span className='badge bg-danger'>Invalid</span>
        )
    }

    const onSubmit = async () => {
        try {
            setLoading(true)
            dispatch(contentLoadingChange(true))
            if (!name?.firstName) {
                toast.error("Invalid First Name");
                setLoading(false)
                dispatch(contentLoadingChange(false))
                return
            }
            if (!name?.lastName) {
                toast.error("Invalid Last Name");
                setLoading(false)
                dispatch(contentLoadingChange(false))
                return
            }
            const response = await Handler({ method: "patch", url: `/staff/customer/${customerDetails?.customerId}/kyc/final/review`, data: { toStatus: "verified", ...name } })
            if (response?.success) {
                toast.success("Verified Successfully")
                setTimeout(() => {
                    dispatch(contentLoadingChange(false))
                    setLoading(false)
                    onVerified?.()
                }, 1500)
            } else {
                setLoading(false)
                dispatch(contentLoadingChange(false))
                toast.error(response?.data?.message || "Cannot verify")
            }
        } catch (error) {
            toast.error("Something went wrong")
        } finally {

        }
    }

    const kyc = customerDetails?.kyc

    return (
        <>
            <table className='table'>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Document No</th>
                        <th>Name</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>

                    {kyc?.aadhaar?.aadhaarNo && (
                        <tr>
                            <td>Aadhaar</td>
                            <td>{kyc.aadhaar.aadhaarNo}</td>
                            <td className='text-wrap' >{kyc?.aadhaar?.aadhaarDetails?.aadhaar_xml_data?.full_name || "-"}</td>
                            <td>{renderStatus(kyc?.aadhaar?.aadhaarDetails)}</td>
                        </tr>
                    )}

                    {kyc?.dl?.dlNo && (
                        <tr>
                            <td>DL</td>
                            <td>{kyc.dl.dlNo}</td>
                            <td className='text-wrap' >{kyc?.dl?.dlData?.name || "-"}</td>
                            <td>{renderStatus(kyc?.dl?.dlData)}</td>
                        </tr>
                    )}

                    {kyc?.passport?.passportNo && (
                        <tr>
                            <td>Passport</td>
                            <td>{kyc.passport.passportNo}</td>
                            <td className='text-wrap' >{kyc?.passport?.passportData?.full_name || "-"}</td>
                            <td>{renderStatus(kyc?.passport?.passportData)}</td>
                        </tr>
                    )}

                    {kyc?.voter?.voterId && (
                        <tr>
                            <td>Voter</td>
                            <td>{kyc.voter.voterId}</td>
                            <td>{kyc?.voter?.voterData?.name || "-"}</td>
                            <td>{renderStatus(kyc?.voter?.voterData)}</td>
                        </tr>
                    )}

                </tbody>
            </table>

            <div className='my-3' >
                <div className="mb-3">
                    <label htmlFor="firstName" className="form-label">First Name</label>
                    <input type="text" autoComplete='off' disabled={loading} className="form-control" id="firstName" name='firstName' value={name?.firstName} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="lastName" className="form-label">Last Name</label>
                    <input type="text" autoComplete='off' disabled={loading} className="form-control" id="lastName" name='lastName' value={name?.lastName} onChange={handleChange} />
                </div>
            </div>

            <div className='d-flex justify-content-center mt-3'>
                <button
                    className='btn btn-primary px-4'
                    disabled={loading}
                    onClick={onSubmit}
                >
                    {loading ? "Verifying..." : "Verify"}
                </button>
            </div>
        </>
    )
}

export default FinalVerify